import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBSCwSKU7SuX6rZbLn6_v2hc-2DFoJhTK8",
  authDomain: "quiz-game-2c8bd.firebaseapp.com",
  projectId: "quiz-game-2c8bd",
  storageBucket: "quiz-game-2c8bd.firebasestorage.app",
  messagingSenderId: "587831161540",
  appId: "1:587831161540:web:f41978fb9d5f770f510f91"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;